"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GaugeDashboard: ['gauge-dashboard', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,2A12.013,12.013,0,0,0,0,14v2.5A2.5,2.5,0,0,0,2.5,19h19A2.5,2.5,0,0,0,24,16.5V14A12.013,12.013,0,0,0,12,2Zm9.5,13.25h-2a.75.75,0,0,1,0-1.5h2a.75.75,0,0,1,0,1.5Zm-2.754-3.816a.751.751,0,0,1-.376-1.4l1.732-1a.75.75,0,1,1,.75,1.3l-1.732,1A.739.739,0,0,1,18.746,11.434ZM14.75,14a2.746,2.746,0,1,1-1.937-2.628l3.741-5.758a.75.75,0,1,1,1.258.818l-3.743,5.76A2.734,2.734,0,0,1,14.75,14ZM8.192,8.4A.757.757,0,0,1,7.167,8.13l-1-1.732a.75.75,0,1,1,1.3-.75l1,1.732A.749.749,0,0,1,8.192,8.4ZM4.88,11.332l-1.732-1a.75.75,0,0,1,.75-1.3l1.732,1A.749.749,0,0,1,5.9,11.058.76.76,0,0,1,4.88,11.332ZM5.25,14.5a.75.75,0,0,1-.75.75h-2a.75.75,0,0,1,0-1.5h2A.75.75,0,0,1,5.25,14.5ZM12,3.75a.75.75,0,0,1,.75.75v2a.75.75,0,0,1-1.5,0v-2A.75.75,0,0,1,12,3.75Z', 'M10.750 14.000 A1.250 1.250 0 1 0 13.250 14.000 A1.250 1.250 0 1 0 10.750 14.000 Z']],
  GaugeDashboardAlternate: ['gauge-dashboard-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,3.348a12.013,12.013,0,0,0-12,12v2.391a2.916,2.916,0,0,0,2.913,2.913H21.087A2.916,2.916,0,0,0,24,17.739V15.348A12.013,12.013,0,0,0,12,3.348Zm9.087,15.3H2.913A.914.914,0,0,1,2,17.739V16.4H4.5a.75.75,0,0,0,0-1.5H2.01a9.922,9.922,0,0,1,.841-3.589L4.88,12.485a.75.75,0,0,0,.75-1.3l-2.07-1.2A10.052,10.052,0,0,1,6.037,7.325l1.13,1.957a.762.762,0,0,0,1.025.275.75.75,0,0,0,.274-1.025L7.305,6.521A9.911,9.911,0,0,1,11.25,5.376V7.652a.75.75,0,1,0,1.5,0V5.376a10.006,10.006,0,0,1,7.69,4.615l-2.07,1.2a.75.75,0,1,0,.75,1.3l2.029-1.172A9.922,9.922,0,0,1,21.99,14.9H19.5a.75.75,0,1,0,0,1.5H22v1.337A.914.914,0,0,1,21.087,18.652Z', 'M16.565,8.125a.749.749,0,0,0-1.037.221l-3,4.619a2.254,2.254,0,1,0,1.257.818l3-4.62A.751.751,0,0,0,16.565,8.125Z']],
  GaugeDashboard1: ['gauge-dashboard-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,16.25a16.79,16.79,0,0,1,9.152,2.737.5.5,0,0,0,.683-.12A11.93,11.93,0,0,0,24,11.877,12.111,12.111,0,0,0,12.494.01,11.994,11.994,0,0,0,2.165,18.867a.5.5,0,0,0,.683.12A16.792,16.792,0,0,1,12,16.25ZM11.25,3.5a.75.75,0,0,1,1.5,0V5a.75.75,0,0,1-1.5,0ZM5,12.75H3.5a.75.75,0,0,1,0-1.5H5a.75.75,0,0,1,0,1.5ZM7.58,7.58a.748.748,0,0,1-1.06,0L5.459,6.52A.75.75,0,0,1,6.52,5.46L7.58,6.519A.75.75,0,0,1,7.58,7.58Zm4.339,6.866a2.366,2.366,0,0,1-1.687-4.052c.756-.755,7.042-4.63,7.756-5.07a.5.5,0,0,1,.688.688c-.44.714-4.315,7-5.071,7.755A2.376,2.376,0,0,1,11.919,14.446ZM19,12.75a.75.75,0,0,1,0-1.5h1.5a.75.75,0,0,1,0,1.5Z', 'M12,17.75a15.051,15.051,0,0,0-8.031,2.3.508.508,0,0,0-.076.794,11.975,11.975,0,0,0,16.214,0,.507.507,0,0,0-.076-.793A15.046,15.046,0,0,0,12,17.75Z']],
  BrowserGauge1: ['browser-gauge-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.122,17.838H4.163a.735.735,0,0,0,0,1.469H6.122a.735.735,0,1,0,0-1.469Z', 'M7.278,15l-1.7-.979a.735.735,0,1,0-.735,1.272l1.7.98A.735.735,0,0,0,7.278,15Z', 'M8.718,11.417a.735.735,0,0,0-1.273.735l.98,1.7A.735.735,0,0,0,9.7,13.114Z', 'M12,13.428a.735.735,0,0,0,.735-.735V10.735a.735.735,0,0,0-1.47,0v1.958A.735.735,0,0,0,12,13.428Z', 'M19.156,15.289a.735.735,0,0,0-.734-1.274l-1.7.979a.735.735,0,0,0,.368,1.371.726.726,0,0,0,.366-.1Z', 'M19.839,17.836H17.88a.735.735,0,0,0,0,1.469h1.959a.735.735,0,0,0,0-1.469Z', 'M15.5,12.137,11.223,16.41a2.726,2.726,0,0,0-.692,1.673v.489a.774.774,0,0,0,.96.788l.528-.106a2.02,2.02,0,0,0,1.324-1.1L15.7,12.269a.123.123,0,0,0-.2-.132Z', 'M24,2.939A2.942,2.942,0,0,0,21.061,0H2.939A2.942,2.942,0,0,0,0,2.939V21.061A2.942,2.942,0,0,0,2.939,24H21.061A2.942,2.942,0,0,0,24,21.061Zm-22.041,0a.98.98,0,0,1,.98-.98H7.25a.25.25,0,0,1,.25.25V5.25a.25.25,0,0,1-.25.25H2.209a.25.25,0,0,1-.25-.25ZM22.041,21.061a.98.98,0,0,1-.98.98H2.939a.98.98,0,0,1-.98-.98V7.75a.25.25,0,0,1,.25-.25H21.791a.25.25,0,0,1,.25.25Zm0-15.811a.25.25,0,0,1-.25.25H9.75a.25.25,0,0,1-.25-.25V2.209a.25.25,0,0,1,.25-.25H21.061a.98.98,0,0,1,.98.98Z']],
  BrowserGauge: ['browser-gauge', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.122,16.9H4.163a.735.735,0,0,0,0,1.469H6.122a.735.735,0,1,0,0-1.469Z', 'M7.278,14.057l-1.7-.979a.735.735,0,1,0-.735,1.272l1.7.98a.735.735,0,0,0,.735-1.273Z', 'M8.718,10.477a.735.735,0,0,0-1.273.735l.98,1.7A.735.735,0,0,0,9.7,12.174Z', 'M12,12.488a.735.735,0,0,0,.735-.735V9.8a.735.735,0,0,0-1.47,0v1.958A.735.735,0,0,0,12,12.488Z', 'M19.156,14.349a.735.735,0,0,0-.734-1.273l-1.7.978a.735.735,0,0,0,.368,1.371.726.726,0,0,0,.366-.1Z', 'M19.839,16.9H17.88a.735.735,0,0,0,0,1.469h1.959a.735.735,0,0,0,0-1.469Z', 'M15.5,11.2,11.223,15.47a2.726,2.726,0,0,0-.692,1.673v.489a.774.774,0,0,0,.96.788l.528-.105a2.024,2.024,0,0,0,1.324-1.1L15.7,11.329a.123.123,0,0,0-.2-.132Z', 'M2.939,24H21.061A2.942,2.942,0,0,0,24,21.061V2.939A2.942,2.942,0,0,0,21.061,0H2.939A2.942,2.942,0,0,0,0,2.939V21.061A2.942,2.942,0,0,0,2.939,24ZM11.02,2.939a.735.735,0,1,1-.734-.735A.734.734,0,0,1,11.02,2.939Zm-2.938,0A.735.735,0,1,1,7.347,2.2.735.735,0,0,1,8.082,2.939Zm-2.939,0A.735.735,0,1,1,4.408,2.2.735.735,0,0,1,5.143,2.939Zm15.918,19.1H2.939a.98.98,0,0,1-.98-.98V6.633a1,1,0,0,1,1-1H21.041a1,1,0,0,1,1,1V21.061A.98.98,0,0,1,21.061,22.041Z']],
  LayoutCornersDashboard1: ['layout-corners-dashboard-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 5.000 A5.000 5.000 0 1 0 10.000 5.000 A5.000 5.000 0 1 0 0.000 5.000 Z', 'M14.000 5.000 A5.000 5.000 0 1 0 24.000 5.000 A5.000 5.000 0 1 0 14.000 5.000 Z', 'M0.000 19.000 A5.000 5.000 0 1 0 10.000 19.000 A5.000 5.000 0 1 0 0.000 19.000 Z', 'M14.000 19.000 A5.000 5.000 0 1 0 24.000 19.000 A5.000 5.000 0 1 0 14.000 19.000 Z']],
  PieLineGraphDesktop: ['pie-line-graph-desktop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.35,20.681a.5.5,0,0,0-.385-.181h-3.93a.5.5,0,0,0-.385.181l-2.1,2.532A.5.5,0,0,0,7.96,24h8.079a.5.5,0,0,0,.41-.787Z', 'M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v16A1.5,1.5,0,0,0,1.5,19h21A1.5,1.5,0,0,0,24,17.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,14.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z', 'M10.02,10.444a1.057,1.057,0,0,0,.105-.124l2.687-3.734a1,1,0,1,0-1.623-1.168l-2.016,2.8a.249.249,0,0,1-.331.069L7.327,7.38A1,1,0,0,0,6,7.66L3.684,10.923a1,1,0,0,0,1.632,1.158L6.959,9.759a.251.251,0,0,1,.333-.069l1.507.9A1,1,0,0,0,10.02,10.444Z', 'M14.500 4.000 L16.500 4.000 L16.500 12.000 L14.500 12.000 Z', 'M18.000 6.000 L20.000 6.000 L20.000 12.000 L18.000 12.000 Z']],
  GaugeDashboard1Alternate: ['gauge-dashboard-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm7.327,18.8a15.838,15.838,0,0,0-14.655,0,10,10,0,1,1,14.655,0Z', 'M5.5,11.25H4a.75.75,0,0,0,0,1.5H5.5a.75.75,0,0,0,0-1.5Z', 'M6.97,5.91A.75.75,0,1,0,5.91,6.97L6.97,8.03A.75.75,0,1,0,8.03,6.97Z', 'M12,6.25a.75.75,0,0,0,.75-.75V4a.75.75,0,0,0-1.5,0V5.5A.75.75,0,0,0,12,6.25Z', 'M20,11.25H18.5a.75.75,0,0,0,0,1.5H20a.75.75,0,0,0,0-1.5Z', 'M18.354,6.646a.5.5,0,0,0-.611-.075c-.689.414-6.753,4.066-7.511,4.824a2.389,2.389,0,0,0,0,3.373,2.423,2.423,0,0,0,3.373,0c.758-.758,4.41-6.822,4.824-7.51A.5.5,0,0,0,18.354,6.646Z']],
  LayoutCornersDashboard: ['layout-corners-dashboard', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM16.973,21.853a.5.5,0,0,1-.354.147H7.381a.5.5,0,0,1-.354-.147L2.146,16.972A.5.5,0,0,1,2,16.619V7.381a.5.5,0,0,1,.146-.354L7.027,2.146A.5.5,0,0,1,7.381,2h9.238a.5.5,0,0,1,.354.146l4.881,4.882A.5.5,0,0,1,22,7.381v9.236a.5.5,0,0,1-.146.354Z']],
  PieLineGraph: ['pie-line-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.939,24H21.061A2.942,2.942,0,0,0,24,21.061V2.939A2.942,2.942,0,0,0,21.061,0H2.939A2.942,2.942,0,0,0,0,2.939V21.061A2.942,2.942,0,0,0,2.939,24Zm18.122-1.959H2.939a.98.98,0,0,1-.98-.98V3a1,1,0,0,1,1-1H21.041a1,1,0,0,1,1,1V21.061A.98.98,0,0,1,21.061,22.041Z', 'M18.836,15.592l-2.064,1.832a.252.252,0,0,1-.315.014l-1.366-1.012a1.878,1.878,0,0,0-1.135-.339,1.769,1.769,0,0,0-1.119.431L10.32,18.752a1,1,0,0,0,1.328,1.5l2.233-1.982a.25.25,0,0,1,.314-.014l1.366,1.012a1.875,1.875,0,0,0,1.135.34,1.77,1.77,0,0,0,1.119-.432l2.349-2.084a1,1,0,1,0-1.328-1.5Z', 'M14.331,10.123a.208.208,0,0,0-.155-.087L10.11,9.722a.21.21,0,0,0-.222.257l.884,3.981a.214.214,0,0,0,.108.141.211.211,0,0,0,.177.009A5.507,5.507,0,0,0,14.365,10.3.208.208,0,0,0,14.331,10.123Z', 'M7.209,3.809a.212.212,0,0,0-.116.3L9.359,8.3a.209.209,0,0,0,.169.109l4.744.367a.211.211,0,0,0,.227-.229,5.5,5.5,0,0,0-7.29-4.733Z', 'M5.836,4.608a.21.21,0,0,0-.173.039A5.5,5.5,0,0,0,9.02,14.5c.107,0,.213,0,.319-.009a.208.208,0,0,0,.156-.084.214.214,0,0,0,.038-.173L8.426,9.253a.227.227,0,0,0-.02-.055L5.978,4.714A.211.211,0,0,0,5.836,4.608Z', 'M17.500 5.500 A1.000 1.000 0 1 0 19.500 5.500 A1.000 1.000 0 1 0 17.500 5.500 Z', 'M17.500 8.500 A1.000 1.000 0 1 0 19.500 8.500 A1.000 1.000 0 1 0 17.500 8.500 Z', 'M17.500 11.500 A1.000 1.000 0 1 0 19.500 11.500 A1.000 1.000 0 1 0 17.500 11.500 Z']],
  LayoutDashboard: ['layout-dashboard', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.793.786A1,1,0,0,0,.5,1.493V12.508a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-11a1,1,0,0,0-1-1L1.5.493A1,1,0,0,0,.793.786Z', 'M22.5.493l-8,.014a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V1.493a1,1,0,0,0-1-1Z', 'M10.207,23.214a1,1,0,0,0,.293-.707v-5a1,1,0,0,0-1-1h-8a1,1,0,0,0-1,1v4.985a1,1,0,0,0,1,1l8,.014A1,1,0,0,0,10.207,23.214Z', 'M22.5,10.508h-8a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1l8-.014a1,1,0,0,0,1-1V11.508A1,1,0,0,0,22.5,10.508Z']]
};
exports["default"] = _default;